import request from '@/utils/request'

export function chat(data) {
  return request({
    url: '/api/an/askChatGPT',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/chat.js